import axios from 'axios';

const Api = axios.create({
  baseURL: import.meta.env.MODE === 'development' ? 'http://localhost:4000/api' : '/api',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
});

Api.interceptors.request.use((config) => {
  const token = window.localStorage.getItem('rheto');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
}, (error) => {
  // Handle request errors
  return Promise.reject(error);
});


export default Api;
